import { all, fork } from "redux-saga/effects";
import startup from "./StartupSaga";
import AuthSaga from "./auth/AuthSaga";
import AutorizacionSaga from "./autorizacion/AutorizacionSaga";
import AseguradoSaga from "./asegurado/AseguradoSaga";
import PrestadorSaga from "./prestador/PrestadorSaga";
import ProcedimientoSaga from "./procedimiento/ProcedimientoSaga";
import PrecertificacionSaga from "./precertificacion/PrecertificacionSaga";
import CatalogoSaga from "./catalogo/CatalogoSaga";
import VoucherSaga from "./voucher/VoucherSaga";
import IngresoSaga from "./ingreso/IngresoSaga";


export default function* root() {
  yield fork(startup);
  yield all([
    ...AuthSaga,
    ...AutorizacionSaga,
    ...AseguradoSaga,
    ...PrestadorSaga,
    ...ProcedimientoSaga,
    ...PrecertificacionSaga,
    ...CatalogoSaga,
    ...VoucherSaga,
    ...IngresoSaga,
  ]);
}